export default __webpack_public_path__ + "static/media/saturation.e2ffbe7d.svg";